import { render, staticRenderFns } from "./activityEdit.vue?vue&type=template&id=06b98670&scoped=true"
import script from "./activityEdit.vue?vue&type=script&lang=js"
export * from "./activityEdit.vue?vue&type=script&lang=js"
import style0 from "./activityEdit.vue?vue&type=style&index=0&id=06b98670&prod&lang=scss&scoped=true"
import style1 from "./activityEdit.vue?vue&type=style&index=1&id=06b98670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b98670",
  null
  
)

export default component.exports